import { FC, useState } from 'react';
import { Stack } from 'modules/common/components/Stack/Stack';
import { StarRating } from 'modules/common/components/StarRating/StarRating';
import { Button } from 'modules/common/components/Button/Button';
import { LabelTextarea } from 'modules/common/components/LabeledInputs/LabelTextarea';
import Styles from './scoring-report.module.scss';

interface ScoreField {
  id: string;
  label: string;
  rating: number;
}

export const ScoringReport: FC = () => {
  const [scores, setScores] = useState<ScoreField[]>([
    { id: 'tone', label: 'Tone', rating: 0 },
    { id: 'errorRate', label: 'Error Rate', rating: 0 },
    { id: 'fluidness', label: 'Fluidness of Delivery', rating: 0 },
    { id: 'audioQuality', label: 'Audio Quality', rating: 0 },
    { id: 'technicalErrors', label: 'Technical Audio Glitches/Errors', rating: 0 },
    { id: 'intonation', label: 'Intonation', rating: 0 },
    { id: 'pronunciation', label: 'Pronunciation', rating: 0 },
    { id: 'emotion', label: 'Emotion', rating: 0 },
    { id: 'storytelling', label: 'Storytelling', rating: 0 },
  ]);

  const [comments, setComments] = useState('');

  const handleRatingChange = (id: string, rating: number) => {
    setScores(scores.map(score => 
      score.id === id ? { ...score, rating } : score
    ));
  };

  const handleSubmit = () => {
    // TODO: Implement submission logic
    console.log('Submitted scores:', scores);
    console.log('Additional comments:', comments);
  };

  return (
    <Stack direction="column" spacing="4" className={Styles.container}>
      <h2 className={Styles.title}>Scoring Report</h2>
      
      {scores.map(({ id, label, rating }) => (
        <Stack key={id} direction="column" spacing="2">
          <label className={Styles.label}>{label}</label>
          <StarRating
            rating={rating}
            onChange={(newRating) => handleRatingChange(id, newRating)}
          />
        </Stack>
      ))}

      <Stack direction="column" spacing="2" className={Styles.commentsSection}>
        <LabelTextarea
          labelText="Additional Comments"
          value={comments}
          onChangeValue={setComments}
          placeholder="Enter any additional feedback or observations..."
          rows={5}
        />
      </Stack>

      <Button
        onClick={handleSubmit}
        disabled={scores.some(score => score.rating === 0)}
        className={Styles.submitButton}
      >
        Submit Report
      </Button>
    </Stack>
  );
}; 